export default "/dist/files/brouillons_vide.ec2325c621c92dbd095e592e19405617.svg";